import { Injectable } from '@angular/core'
import { AuthService } from '../../services/auth.services'
import { RestServices } from '../../services/rest.services'
import { Router } from '@angular/router'

@Injectable()

export class SelectclientService {


    constructor(private authData: AuthService, private router: Router, private restApi: RestServices) {
    }

    resourceUrl = 'resource'
    dataSearchResponseService: any

    getDatasearch() {
        const resourceDataAccessLog = {
            actions: [],
            status: {
                clientMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    searches: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    if (success) {
                        const dataSearchResponseService = success
                        this.dataSearchResponseService = success
                        return dataSearchResponseService
                    }
                },
            )
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/services/client/selectclient.service.ts